interface Resolvers<T> {
  resolve: (value: T) => void;
  reject: (error: unknown) => void;
}

export interface Deferred<T> extends Resolvers<T> {
  promise: PromiseLike<T>;
}

export const deferred = <T = void>(): Deferred<T> => {
  let resolvers!: Resolvers<T>;

  const promise = new Promise<T>((resolve, reject) => {
    resolvers = { resolve, reject };
  });

  return { ...resolvers, promise };
};
